"use client";

import {
  ManagerService,
  type ManagerCoachingEmailResponse,
} from "@/api-client/manager";
import { getQueryKey, QUERY_KEYS } from "@/lib/query-keys";
import { useAuthenticatedQuery } from "./use-authenticated-query";

interface UseManagerCoachingEmailParams {
  repEmail: string | null | undefined;
  accountId?: number | null;
  enabled?: boolean;
}

export function useManagerCoachingEmail({
  repEmail,
  accountId,
  enabled = true,
}: UseManagerCoachingEmailParams) {
  const trimmedRepEmail = repEmail?.trim() ?? "";
  const isAccountMode = accountId != null && accountId > 0;

  const queryKey = getQueryKey(QUERY_KEYS.MANAGER_COACHING_EMAIL, {
    accountId: isAccountMode ? accountId! : 0,
    repEmail: trimmedRepEmail,
  });

  return useAuthenticatedQuery<ManagerCoachingEmailResponse>({
    queryKey: [queryKey],
    queryFn: () => {
      if (!trimmedRepEmail) throw new Error("Rep email is required");
      if (isAccountMode) {
        return ManagerService.getAccountCoachingEmail({
          accountId: accountId!,
          repEmail: trimmedRepEmail,
        });
      }
      return ManagerService.getRepCoachingEmail({ repEmail: trimmedRepEmail });
    },
    enabled:
      enabled &&
      Boolean(trimmedRepEmail) &&
      (isAccountMode ? Boolean(accountId) : true),
    staleTime: 60 * 1000,
    retry: false,
  });
}
